export enum LanguageEnum {
    ENGLISH = 'ENGLISH',
    GERMAN = 'GERMAN'
}
